import { scaleIn } from "./scale";
import { expandCollapse } from "./expand-collapse";
import {
  fadeIn,
  fadeInBottom,
  fadeInLeft,
  fadeInRight,
  fadeInRight20,
  fadeInTop,
  fadeInUp,
  fadeOut,
  fadeOutBottom,
  fadeOutLeft,
  fadeOutRight,
  fadeOutTop,
} from "./fade";
import { shake } from "./shake";
import {
  slideInBottom,
  slideInLeft,
  slideInRight,
  slideInTop,
  slideOutBottom,
  slideOutLeft,
  slideOutRight,
  slideOutTop,
} from "./slide";
import { zoomIn, zoomOut } from "./zoom";
import { stagger20ms, stagger40ms, stagger60ms, stagger80ms } from "./stagger";
import { scaleInOut } from "./scale-in-out";

export const PropiuAnimations = [
  expandCollapse,
  fadeIn,
  fadeInTop,
  fadeInBottom,
  fadeInLeft,
  fadeInRight,
  fadeInRight20,
  fadeInUp,
  fadeOut,
  fadeOutTop,
  fadeOutBottom,
  fadeOutLeft,
  fadeOutRight,
  shake,
  slideInTop,
  slideInBottom,
  slideInLeft,
  slideInRight,
  slideOutTop,
  slideOutBottom,
  slideOutLeft,
  slideOutRight,
  zoomIn,
  zoomOut,
  scaleIn,
  scaleInOut,
  stagger20ms,
  stagger40ms,
  stagger60ms,
  stagger80ms,
];
